import "./App.css";

function App() {
    return (
        <div className="App">
            <header className="App-header">Feature 브랜치 👀</header>
        </div>
    );
}

export default App;
